import React from "react";

const SingleVideoSkeleton = () => {
  return (
    <div className="col-span-full w-full space-y-8 lg:col-span-2 animate-pulse">
      <div className="w-full h-[25rem] rounded-sm bg-gray-300"></div>
      <div>
        <div className="w-full h-6 rounded-sm bg-gray-300"></div>
        <div className="pb-4 flex items-center justify-between border-b mt-2">
          <div className="w-2/4 md:w-2/6 h-3 rounded-sm bg-gray-300"></div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-full bg-gray-300"></div>
            <div className="w-6 h-6 rounded-full bg-gray-300"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleVideoSkeleton;
